export { SearchBar } from '../src/SearchBar';
